// @flow

// import axios from 'axios';

import { PATTERNS, PATTERNS_DETAIL } from './pattern.data';
// import { API_BASE } from './settings';


export default class PatternService {

    getAll() {
        return new Promise((resolve, reject) => {
            resolve(PATTERNS.results);
            // axios.get(`${API_BASE}/api/patterns/`)
            //     .then((res) => {
            //         resolve(res.data.results);

            //     }).catch((error) => {
            //         reject();

            //     });

        });
    }


    get(patternId) {
        return new Promise((resolve, reject) => {
            resolve(PATTERNS_DETAIL[patternId]);
            // axios.get(`${API_BASE}/api/patterns/${patternId}/`)
            //     .then((res) => {
            //         resolve(res.data);

            //     }).catch((error) => {
            //         reject();

            //     });

        });
    }

}



// WEBPACK FOOTER //
// ./src/services/pattern.js